var exports = {
  "kL": "x61f99309--239e12--container",
  "R_": "x61f99309--239e12--heading",
  "x6": "x61f99309--239e12--button",
  "Qs": "x61f99309--239e12--content",
  "AS": "x61f99309--239e12--item",
};

module.exports = exports;
